// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__abMnU","name":"ConsentHeader_name__2oCJN","birthday":"ConsentHeader_birthday__2BX9A","skeleton":"ConsentHeader_skeleton__21GlL"};